import { useState } from 'react';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import { addCurrentThemeClassToEle } from '@/utils';

import "@/components/timeline/commonStyleForWatchModles/style.css"
import LightGrayCross from "@/assets/icons/lightGrayCross.png";

import { themes } from '@/constants/colors_v2';

function WatchModle1(props: any) {
    const { timeline, common } = useLocalTranslation();
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    return (
        <Modal
            show={props.show}
            onHide={() => props.handleClose()} centered>
            <div
                className={` ${props.stepForModal1 === 1 ? 'bg-[#EEFFE1] ' : ''} p-[20px] ${addCurrentThemeClassToEle(currentTheme, 'watchModle1Index')}`}>

                <Modal.Header
                    className={` ${props.stepForModal1 === 0 ? 'mb-[10px]' : ''} p-0 border-0`}>

                    {currentTheme === themes.dark ? (
                        <div className='darkThemetopCloseButtonHelperModelCon'>
                            <Modal.Title className='text-[16px] font-semibold watchModel12Title'>
                                {props.stepForModal1 === 1 &&
                                    <p>{props.modalTitle}</p>
                                }
                            </Modal.Title>

                            <button
                                onClick={() => props.handleClose()}
                                type="button"
                                className='text-[14px]'
                                aria-label="Close">
                                <img src={LightGrayCross} alt='LightGrayCross' className='w-[14px]' />
                            </button>
                        </div>
                    ) : (
                        <>
                            <Modal.Title className='text-[16px] font-semibold watchModel12Title'>
                                {props.stepForModal1 === 1 &&
                                    <p>{props.modalTitle}</p>
                                }
                            </Modal.Title>

                            <button
                                onClick={() => props.handleClose()}
                                type="button"
                                className='btn-close topCloseButtonHelper'
                                aria-label="Close">
                            </button>

                        </>
                    )}


                    {/* {props.stepForModal1 === 1 &&
                        <Modal.Title className='text-[15px] font-semibold text-[#397D05]'>
                            <p>{props.modalTitle}</p>
                        </Modal.Title>
                    }
                    <button
                        onClick={() => props.handleClose()}
                        type="button"
                        className="btn-close text-[14px]" aria-label="Close"></button>
                         */}


                </Modal.Header>

                <Modal.Body className='p-0'>
                    {props.stepForModal1 === 0 &&
                        <>
                            <p className='mb-[13px]'>{timeline.watchSection.popUp1.p1}</p>
                            <p className='mb-[12px]'>{timeline.watchSection.popUp1.p2}</p>
                            <div className='flex gap-[10px]'>
                                <button
                                    onClick={() => props.startCourseNow()}
                                    className={`w-1/2 cursor-pointer watchModel12LeftBtn py-[7px] rounded-[5px] text-[14px]`}>
                                    {timeline.watchSection.popUp1.b1}
                                </button>

                                <button
                                    onClick={() => props.handleClose()}
                                    className='w-1/2 cursor-pointer bg-[#1573FE] py-[7px] text-white rounded-[5px] text-[14px]'>
                                    {common.statusText.cancleBtn}
                                </button>
                            </div>
                        </>
                    }
                </Modal.Body>

            </div>
        </Modal>
    );
}

export default WatchModle1;
